<template>
  <div>
    <div class="ion-text-end u-color-primary">
      Bevorzugte Tage und Tageszeiten
    </div>
    <div class="c-matrix" v-if="selected.length > 0">
      <div></div>
      <div v-for="time in times" :key="time" class="ion-text-center">
        {{ time }}
      </div>
      <div
        v-for="(day, index) in days"
        :key="day"
        :style="{ 'grid-row-start': index + 2 }"
      >
        {{ day }}
      </div>
      <template v-for="(day, dayIndex) in days" :key="day">
        <div
          v-for="(time, timeIndex) in times"
          :key="time"
          class="ion-text-center"
        >
          <ion-checkbox
            v-if="
              dayIndex * times.length + timeIndex <
              (days.length - 1) * times.length + (times.length - 1)
            "
            v-model="selected[dayIndex * times.length + timeIndex].isChecked"
          ></ion-checkbox>
        </div>
      </template>
    </div>
    <next-question-button :disabled="valueString === ''" @click="emitValues" />
  </div>
</template>

<script>
import NextQuestionButton from "./NextQuestionButton";
import { IonCheckbox } from "@ionic/vue";

export default {
  emits: ["done"],
  components: {
    NextQuestionButton,
    IonCheckbox,
  },
  props: {
    question: {
      required: true,
      type: Object,
    },
  },
  setup() {
    return {};
  },
  data() {
    return {
      days: ["MO", "DI", "MI", "DO", "FR", "SA"],
      times: ["Morgens", "Tagsüber", "Abends"],
      selected: [],
    };
  },
  mounted() {
    for (const day of this.days) {
      for (const time of this.times) {
        this.selected.push({ val: day + " " + time, isChecked: false });
      }
    }
  },
  methods: {
    emitValues() {
      this.$emit("done", {
        value: this.valueString,
        id: this.question.id,
      });
    },
  },
  computed: {
    valueString() {
      let value = "";
      for (const [index, entry] of this.selected.entries()) {
        if (entry.isChecked) {
          if (value !== "" && index < this.selected.length - 1) {
            value += ", ";
          }
          value += entry.val;
        }
      }
      return value;
    },
  },
};
</script>

<style lang="scss" scoped>
.c-matrix {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-gap: 10px;
  color: var(--ion-color-primary);
  border: 1px solid var(--ion-color-primary);
  border-radius: 16px;
  padding: 20px;
  margin-top: 5px;
}
</style>
